var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("breadcrumb.unit_detail")))
      ]),
      _c(
        "b-field",
        {
          attrs: {
            label: _vm.$t("label.unit_name"),
            message: _vm.errors.has("name")
              ? _vm.$t("messages.field_is_required")
              : "",
            type: { "is-danger": _vm.errors.has("name") }
          }
        },
        [
          _c("b-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: { name: "name", disabled: !_vm.canEdit() },
            model: {
              value: _vm.selected.name,
              callback: function($$v) {
                _vm.$set(_vm.selected, "name", $$v)
              },
              expression: "selected.name"
            }
          })
        ],
        1
      ),
      !_vm.isSupperUnit(_vm.selected) && _vm.canEdit()
        ? _c(
            "b-field",
            { attrs: { label: _vm.$t("label.logo") } },
            [
              _c(
                "b-upload",
                {
                  attrs: { "drag-drop": "" },
                  model: {
                    value: _vm.uploadFile,
                    callback: function($$v) {
                      _vm.uploadFile = $$v
                    },
                    expression: "uploadFile"
                  }
                },
                [
                  _c("section", { staticClass: "section" }, [
                    _c("div", { staticClass: "content has-text-centered" }, [
                      _c(
                        "p",
                        [
                          _c("b-icon", {
                            attrs: { icon: "upload", size: "is-large" }
                          })
                        ],
                        1
                      ),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("messages.drop_file_here_or_select_a_file")
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.uploadFile
        ? _c(
            "b-field",
            [
              _c(
                "b-tag",
                {
                  attrs: {
                    size: "is-medium",
                    closable: "",
                    "aria-close-label": "Remove"
                  },
                  on: {
                    close: function($event) {
                      _vm.uploadFile = null
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.uploadFile.name))]
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isSupperUnit(_vm.selected)
        ? _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("label.customer_name"),
                message: _vm.errors.has("customer_name")
                  ? _vm.$t("messages.field_is_required")
                  : "",
                type: { "is-danger": _vm.errors.has("customer_name") }
              }
            },
            [
              _c("b-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "customer_name", disabled: !_vm.canEdit() },
                model: {
                  value: _vm.selected.customer_name,
                  callback: function($$v) {
                    _vm.$set(_vm.selected, "customer_name", $$v)
                  },
                  expression: "selected.customer_name"
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.isSupperUnit(_vm.selected)
        ? _c(
            "b-field",
            { attrs: { label: _vm.$t("label.address") } },
            [
              _c("b-input", {
                attrs: { name: "address", disabled: !_vm.canEdit() },
                model: {
                  value: _vm.selected.address,
                  callback: function($$v) {
                    _vm.$set(_vm.selected, "address", $$v)
                  },
                  expression: "selected.address"
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.isSupperUnit(_vm.selected)
        ? _c(
            "b-field",
            { attrs: { label: _vm.$t("label.token") } },
            [
              _c("b-input", {
                attrs: { name: "token", disabled: !_vm.canEdit() },
                model: {
                  value: _vm.selected.token,
                  callback: function($$v) {
                    _vm.$set(_vm.selected, "token", $$v)
                  },
                  expression: "selected.token"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("label.domains"), addons: false } },
        _vm._l(_vm.selected.domains, function(item, index) {
          return _c(
            "div",
            { key: index },
            [
              _c(
                "b-field",
                {
                  staticClass: "m-b-sm",
                  attrs: {
                    message: _vm.errors.has("domains" + index)
                      ? _vm.$t("messages.field_is_required")
                      : "",
                    type: { "is-danger": _vm.errors.has("domains" + index) }
                  }
                },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        grouped: "",
                        type: { "is-danger": _vm.errors.has("domains" + index) }
                      }
                    },
                    [
                      _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.canEdit(),
                          name: "domains" + index,
                          expanded: ""
                        },
                        model: {
                          value: _vm.selected.domains[index],
                          callback: function($$v) {
                            _vm.$set(_vm.selected.domains, index, $$v)
                          },
                          expression: "selected.domains[index]"
                        }
                      }),
                      _c("p", { staticClass: "control buttons" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            attrs: { disabled: !_vm.canEdit() },
                            on: {
                              click: function($event) {
                                return _vm.handleAddDomain(index)
                              }
                            }
                          },
                          [_c("b-icon", { attrs: { icon: "plus" } })],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button is-danger",
                            attrs: {
                              disabled:
                                _vm.selected.domains.length === 1 ||
                                !_vm.canEdit()
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDeleteDomain(index)
                              }
                            }
                          },
                          [_c("b-icon", { attrs: { icon: "minus" } })],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _c(
        "b-field",
        {
          attrs: {
            label: _vm.$t("label.threshold"),
            type: { "is-danger": _vm.errors.has("threshold") }
          },
          scopedSlots: _vm._u([
            {
              key: "message",
              fn: function() {
                return _vm._l(_vm.errors.collect("threshold"), function(
                  error,
                  index
                ) {
                  return _c("div", { key: index }, [
                    _vm._v(" " + _vm._s(error) + " ")
                  ])
                })
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: { type: "number", name: "threshold" },
            model: {
              value: _vm.selected.threshold,
              callback: function($$v) {
                _vm.$set(_vm.selected, "threshold", $$v)
              },
              expression: "selected.threshold"
            }
          })
        ],
        1
      ),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("label.api_keys"), addons: false } },
        [
          !_vm.selected.api_keys.length
            ? _c("b-field", [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { disabled: !_vm.canEdit() },
                    on: {
                      click: function($event) {
                        return _vm.handleAddApiKey(-1)
                      }
                    }
                  },
                  [_c("b-icon", { attrs: { icon: "plus" } })],
                  1
                )
              ])
            : _vm._e(),
          _vm._l(_vm.apiKeys, function(item, api_key_index) {
            return _c(
              "div",
              { key: api_key_index },
              [
                _c(
                  "b-field",
                  { staticClass: "m-b-sm" },
                  [
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c(
                          "p",
                          { staticClass: "control" },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: { name: "api_key_access_right" },
                                model: {
                                  value:
                                    _vm.selected.api_keys[api_key_index]
                                      .access_right,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selected.api_keys[api_key_index],
                                      "access_right",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "selected.api_keys[api_key_index].access_right"
                                }
                              },
                              _vm._l(_vm.apiKeyAccessRightOptions, function(
                                access_right_item,
                                index
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: access_right_item.code }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(access_right_item.label)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        ),
                        _c("b-input", {
                          attrs: {
                            expanded: "",
                            name: "api_key" + api_key_index
                          },
                          model: {
                            value: _vm.selected.api_keys[api_key_index].api_key,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.selected.api_keys[api_key_index],
                                "api_key",
                                $$v
                              )
                            },
                            expression:
                              "selected.api_keys[api_key_index].api_key"
                          }
                        }),
                        _c("p", { staticClass: "control buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: { disabled: !_vm.canEdit() },
                              on: {
                                click: function($event) {
                                  return _vm.handleAddApiKey(api_key_index)
                                }
                              }
                            },
                            [_c("b-icon", { attrs: { icon: "plus" } })],
                            1
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "button is-danger",
                              attrs: { disabled: !_vm.canEdit() },
                              on: {
                                click: function($event) {
                                  return _vm.handleDeleteApiKey(api_key_index)
                                }
                              }
                            },
                            [_c("b-icon", { attrs: { icon: "minus" } })],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("label.ip_whitelist") } },
        [
          !_vm.ipWhitelist.length
            ? _c("b-field", [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { disabled: !_vm.canEdit() },
                    on: {
                      click: function($event) {
                        return _vm.handleAddIPAddress(-1)
                      }
                    }
                  },
                  [_c("b-icon", { attrs: { icon: "plus" } })],
                  1
                )
              ])
            : _c(
                "div",
                { staticClass: "w-full" },
                [
                  _c(
                    "b-field",
                    { staticClass: "mb-0", attrs: { position: "is-right" } },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("span", { staticClass: "button" }, [
                          _vm._v(_vm._s(_vm.$t("label.ip_address")))
                        ])
                      ]),
                      _c("b-input", {
                        staticClass: "m-w-300",
                        attrs: {
                          placeholder: _vm.$t("label.search_placeholder")
                        },
                        model: {
                          value: _vm.ipListFilters.searchQuery,
                          callback: function($$v) {
                            _vm.$set(_vm.ipListFilters, "searchQuery", $$v)
                          },
                          expression: "ipListFilters.searchQuery"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "w-full mb-3" },
                    [
                      _c("TablePagination", {
                        attrs: {
                          perPage: _vm.ipListFilters.perPage,
                          currentPage: _vm.ipListFilters.currentPage,
                          numofPage: _vm.ipListFilters.numofPage
                        },
                        on: {
                          "update:perPage": function($event) {
                            return _vm.$set(
                              _vm.ipListFilters,
                              "perPage",
                              $event
                            )
                          },
                          "update:per-page": function($event) {
                            return _vm.$set(
                              _vm.ipListFilters,
                              "perPage",
                              $event
                            )
                          },
                          "update:currentPage": function($event) {
                            return _vm.$set(
                              _vm.ipListFilters,
                              "currentPage",
                              $event
                            )
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(
                              _vm.ipListFilters,
                              "currentPage",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(_vm.IpListFiltered, function(item, ip_address_index) {
                    return _c(
                      "div",
                      { key: "ip_address_list" + ip_address_index },
                      [
                        _c(
                          "b-field",
                          { staticClass: "m-b-sm" },
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  type: {
                                    "is-danger": _vm.errors.has(
                                      "ip_address" + ip_address_index
                                    )
                                  },
                                  message: _vm.errors.has(
                                    "ip_address" + ip_address_index
                                  )
                                    ? _vm.$t("messages.field_is_required")
                                    : "",
                                  grouped: ""
                                }
                              },
                              [
                                _c("b-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    expanded: "",
                                    name: "ip_address" + ip_address_index
                                  },
                                  model: {
                                    value:
                                      _vm.selected.ip_whitelist[
                                        ip_address_index
                                      ].ip_address,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selected.ip_whitelist[
                                          ip_address_index
                                        ],
                                        "ip_address",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selected.ip_whitelist[ip_address_index].ip_address"
                                  }
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control m-w-90 is-flex is-align-items-center"
                                  },
                                  [
                                    _c(
                                      "b-switch",
                                      {
                                        attrs: { type: "is-success" },
                                        model: {
                                          value:
                                            _vm.selected.ip_whitelist[
                                              ip_address_index
                                            ].active,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selected.ip_whitelist[
                                                ip_address_index
                                              ],
                                              "active",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selected.ip_whitelist[ip_address_index].active"
                                        }
                                      },
                                      [
                                        _vm.selected.ip_whitelist[
                                          ip_address_index
                                        ].active
                                          ? _c("span", [_vm._v(" ON ")])
                                          : _c("span", [_vm._v("OFF")])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("p", { staticClass: "control buttons" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      attrs: { disabled: !_vm.canEdit() },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleAddIPAddress(
                                            ip_address_index
                                          )
                                        }
                                      }
                                    },
                                    [_c("b-icon", { attrs: { icon: "plus" } })],
                                    1
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button is-danger",
                                      attrs: { disabled: !_vm.canEdit() },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDeleteIPAddress(
                                            ip_address_index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("b-icon", { attrs: { icon: "minus" } })
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
        ],
        1
      ),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("label.manage_features") } },
        [
          _c(
            "b-table",
            {
              attrs: {
                data: _vm.manageFeaturesList,
                narrowed: true,
                striped: true,
                hoverable: true,
                "pagination-size": "is-small"
              }
            },
            [
              _vm._t("columns"),
              _c("b-table-column", {
                attrs: { field: "Fetures", label: _vm.$t("label.features") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.$t("label." + props.row.label)) + " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("b-table-column", {
                attrs: {
                  field: "Status",
                  label: _vm.$t("label.status"),
                  width: "110"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "b-switch",
                          {
                            attrs: { type: "is-success" },
                            model: {
                              value: props.row.status,
                              callback: function($$v) {
                                _vm.$set(props.row, "status", $$v)
                              },
                              expression: "props.row.status"
                            }
                          },
                          [
                            props.row.status
                              ? _c("span", [_vm._v("ON")])
                              : _c("span", [_vm._v("OFF")])
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("label.db_name") } },
        [
          _c("b-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.selected.db_name,
              callback: function($$v) {
                _vm.$set(_vm.selected, "db_name", $$v)
              },
              expression: "selected.db_name"
            }
          })
        ],
        1
      ),
      _c("b-field", [
        _c("div", { staticClass: "buttons" }, [
          _vm.canEdit()
            ? _c(
                "button",
                {
                  staticClass: "button is-primary has-text-weight-bold",
                  on: {
                    click: function($event) {
                      return _vm.handleApplyChange()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("button.save")) + " ")]
              )
            : _vm._e(),
          !_vm.isSupperUnit(_vm.selected) && _vm.canDelete()
            ? _c(
                "button",
                {
                  staticClass: "button is-danger",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleConfirmCustomDelete()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("button.delete")) + " ")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }